import 'bootstrap/dist/css/bootstrap.min.css';
import React from 'react';
import './theirstories.css';

import { Button, Container } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';

import st2 from '../assets/images/st6.png';
import st3 from '../assets/images/st3.png';

import { Image } from 'react-bootstrap';
import Col from 'react-bootstrap/Col';
import Row from 'react-bootstrap/Row';

export const TheirStories = () => {
    const navigate = useNavigate();
    const [isMobile, setIsMobile] = React.useState(window.innerWidth < 768);
    React.useEffect(() => {
        window.addEventListener("resize", () => {
            const ismobile = window.innerWidth < 768;
            if (ismobile !== isMobile) setIsMobile(ismobile);
        });
    }, [isMobile]);

    const goTomorestories = () => {
        navigate("/SuccessPage");
    };

    return (
        <Container fluid="true" className='story-main' style={{
            marginTop: '4rem'
        }}>
            <div className='story-text'>
                <p className='story-heading' style={{
                    hyphens: "none"
                }}>
                    They met their Match on <span style={{ color: '#4E1173' }}>myTamilDate</span>
                </p>
            </div>
            <Container className='story-content'>
                <Row fluid="true" className="team-row">
                    <Col fluid="true" className="team-col" xs={12} md={3}>
                        <div className="team-item">
                            <Image fluid="true" className='team-image' src={st2} />
                            <div className="successpg-details">
                                <span className='person-name'>Suji & Sinthu</span>
                                <span className='person-title'>Suji & Sinthu's journey Is A Heartwarming...</span>
                                <a href='https://tamilculture.com/mytamildate-love-story-patience-and-taking-chances-brought-suji-sinthu-together' className='read-more'>Read more</a>
                            </div>
                        </div>
                    </Col>
                    <Col className="team-col" xs={12} md={3}>
                        <div className="team-item">
                            <Image fluid="true" className='team-image' src={st3} />
                            <div className="successpg-details">
                                <span className='person-name'>Jenani & Nav</span>
                                <span className='person-title'>Jenani & Nav found each other at the right time...</span>
                                <a href="https://tamilculture.com/mytamildate-love-story-jenani-nav-found-each-other-at-the-right-time-and-right-place-in-life" className='read-more'>Read more</a>
                            </div>
                        </div>
                    </Col>
                </Row>
            </Container>
            <Button className='more-success-btn' onClick={goTomorestories}>More success stories</Button>
        </Container>
    );
};